<template>
  <div>
    <md-list :class="`md-double-line md-dense competitor ${otherClass}`">
      <md-list-item>
        <md-menu v-if="isMine(tournament)" md-size="big" md-direction="bottom-start">
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon v-if="!competitor.isActive">not_interested</md-icon>
            <md-icon v-else-if="competitor.isEliminated">sentiment_dissatisfied</md-icon>
            <md-icon v-else-if="competitor.isReadyToCompete">how_to_reg</md-icon>
            <md-icon v-else>person_outline</md-icon>
          </md-button>

          <md-menu-content>
            <md-menu-item v-if="competitor.isReadyToCompete" @click="toggleReadiness(false)">
              <span>Set status to NOT-ready</span>
              <md-icon>person_outline</md-icon>
            </md-menu-item>
            <md-menu-item v-else-if="!competitor.isEliminated" @click="toggleReadiness(true)">
              <span>Set status to READY</span>
              <md-icon>how_to_reg</md-icon>
            </md-menu-item>

            <md-menu-item @click="showEditDialog = true">
              <span>Edit</span>
              <md-icon>edit</md-icon>
            </md-menu-item>
            <md-menu-item @click="deleteCompetitor()">
              <span>Delete</span>
              <md-icon>delete</md-icon>
            </md-menu-item>
          </md-menu-content>
        </md-menu>

        <!-- Icon representing readiness state -->
        <div class="md-list-item-text">
          <span class="competitor-name">{{competitor.name}}</span>
          <span>{{ otherInfo }}</span>
          <md-tooltip>{{competitor.name}} - {{otherInfo}}</md-tooltip>
        </div>
        <md-button class="md-icon-button" @click="makePayment">
          <span v-if="competitor.amountPaid">${{competitor.amountPaid}}</span>
          <md-icon v-else>attach_money</md-icon>
        </md-button>
      </md-list-item>
    </md-list>

    <CompetitorPaymentDialog
      :tournament="tournament"
      :competitor="competitor"
      :show="showPaymentDialog"
      @onClose="showPaymentDialog = false"
    />
    <UpdateCompetitorDialog
      :tournament="tournament"
      :competitor="competitor"
      :show="showEditDialog"
      @onClose="showEditDialog = false"
    />
  </div>
</template>

<script>
import gql from "graphql-tag";
import { tournamentCompetitorFragment } from "@/graphql/tournament";
import { TournamentTools } from "@/js/helper";
import CompetitorPaymentDialog from "@/components/dialogs/competitorPaymentDialog.vue";
import UpdateCompetitorDialog from "@/components/dialogs/updateCompetitorDialog.vue";

export default {
  name: "Competitor",
  components: { CompetitorPaymentDialog, UpdateCompetitorDialog },
  props: { tournament: Object, competitor: Object },
  data: function() {
    return { showPaymentDialog: false, showEditDialog: false };
  },
  computed: {
    otherClass: {
      get() {
        if (!this.competitor.isActive) return "inactive";
        if (this.competitor.isEliminated) return "eliminated";
        if (this.competitor.isReadyToCompete) return "ready";
        return "not-ready";
      }
    },
    otherInfo: {
      get() {
        const info = [`Ranked ${this.competitor.rank}`];
        if (this.competitor.points)
          info.push(`Points ${this.competitor.points}`);
        return info.join(", ");
      }
    }
  },
  methods: {
    isMine: TournamentTools.isMine,
    makePayment() {
      if (this.isMine(this.tournament)) this.showPaymentDialog = true;
    },
    toggleReadiness(isReady) {
      if (this.isMine(this.tournament))
        return this.$apollo
          .mutate({
            mutation: gql`
              mutation(
                $tournamentId: ID!
                $competitorId: ID!
                $isReady: Boolean!
              ) {
                toggleCompetitorReadiness(
                  tournamentId: $tournamentId
                  competitorId: $competitorId
                  isReady: $isReady
                ) {
                  ...TournamentCompetitor
                }
              }
              ${tournamentCompetitorFragment}
            `,
            variables: {
              tournamentId: this.tournament.id,
              competitorId: this.competitor.id,
              isReady: isReady
            }
          })
          .then(result => {
            //this.$root.$emit("updateTournament", this.tournament.id);
            this.$store.commit(
              "setNotification",
              `${this.competitor.name} is now ${
                isReady ? "ready" : "NOT ready"
              } to compete`
            );
          })
          .catch(err => {
            console.log(err);
            window.alert("Failed to toggle competitor readiness state");
          });
    },
    deleteCompetitor() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $competitorId: ID!) {
              deleteCompetitor(
                tournamentId: $tournamentId
                competitorId: $competitorId
              )
            }
          `,
          variables: {
            tournamentId: this.tournament.id,
            competitorId: this.competitor.id
          }
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            "Competitor has been removed from the tournament"
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to remove competitor");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.competitor-name {
  font-weight: bold;
}
.competitor {
  width: 300px;
  margin: 0;
  border-radius: 4em;
  border: solid;
}
.eliminated {
  background-color: rgb(107, 46, 163) !important;
}
.ready {
  background-color: rgb(33, 104, 33) !important;
}
.not-ready {
  background-color: rgb(194, 58, 99) !important;
}
.inactive {
  background-color: rgb(0, 0, 0) !important;
}
</style>


// WEBPACK FOOTER //
// competitor.vue?5b1c934f